import loadPlugin from "./plugin";
import activateThebelab from "./activateThebelab";
import loadScript from "./loadScript";
import { checkSignInStatus, showLoginPrompt } from "./libreOne";

// load required scripts first
// both is required for jupyter widgets
loadScript(
  "https://cdnjs.cloudflare.com/ajax/libs/require.js/2.3.6/require.min.js"
).then(() => {
  // this line prevents future jquery plugins to be loaded within requirejs
  if (window.define !== undefined) window.define.amd = null;
});

if (document.currentScript.dataset.loadfa !== "false") {
  // loads font-awesome scripts unless otherwise disabled
  loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/js/all.min.js"
  );
  loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/js/v4-shims.min.js"
  );
}

// Adds this plugin to the LibreEditor for later activation
LibreEditor.binderPlugin = (config) => {
  loadPlugin();
  config.toolbar[12].push("enableBinder");
};

document.addEventListener("DOMContentLoaded", () => {
  // Check if any element with the data-executable attribute exists
  const hasExecutable = document.querySelector("[data-executable]") !== null;
  if (!hasExecutable) return;

  // const libreone = checkSignInStatus();
  // if (!libreone) {
  //   console.log(
  //     "Not signed in with LibreOne. Thebelab cells will not be activated."
  //   );
  //   showLoginPrompt();
  //   return;
  // }

  // Activate Thebelab if data-executable exists and user is signed in
  activateThebelab();
});
